import classnames from 'classnames';

import Link from 'molecules/Link';

import styles from 'components/Header/NavDropdownItem/nav-dropdown-item.module.scss';

import type { ComponentPropsWithoutRef, FC } from 'react';

interface NavDropdownItemProps extends ComponentPropsWithoutRef<'li'> {
  link: string;
  title: string;
  modifiers?: string[];
  className?: string;
  handleClick?: () => void;
}

const NavDropdownItem: FC<NavDropdownItemProps> = ({
  link,
  title,
  modifiers = [],
  className,
  handleClick,
  ...props
}) => {
  const linkClasses = classnames(styles.dropdownLink, {
    [styles.bold]: modifiers.includes('bold'),
    [styles.divider]: modifiers.includes('divider'),
    [className || '']: className,
  });

  return (
    <li className={linkClasses} {...props}>
      <Link href={link} onClick={handleClick} data-testid={`dropdownItem--${title.replace(/\s+/g, '-').toLowerCase()}`}>
        {title}
      </Link>
    </li>
  );
};

export default NavDropdownItem;
